import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7849ba48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "info-back" }
const _hoisted_4 = { class: "info-data" }
const _hoisted_5 = { class: "info-welcome" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "info-cards" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "info-point-section" }
const _hoisted_13 = { class: "info-point-wrapper" }
const _hoisted_14 = { class: "fw6" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "info-data-card" }
const _hoisted_18 = { class: "info-card-interface-wrapper" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "info-card-interface-inner" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "vic-card-name-no" }
const _hoisted_23 = ["textContent"]
const _hoisted_24 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: {
          name: 'Home',
          params: {
            lang: _ctx.$i18n.locale
          }
        }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              class: "icon-back",
              "icon-name": "arrow-left"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", {
            textContent: _toDisplayString(_ctx.$t('welcome-back'))
          }, null, 8, _hoisted_6),
          _createElementVNode("h3", {
            class: "info-name",
            textContent: _toDisplayString($setup.selectedMemberData?.ProfileDetails?.FirstName ?? '')
          }, null, 8, _hoisted_7),
          _createElementVNode("h5", {
            textContent: _toDisplayString(_ctx.$t('membership-type'))
          }, null, 8, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.memberMap, (card, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (card > -1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["card", {'--selected': i === $setup.type}]),
                      onClick: ($event: any) => ($setup.onMemberTypeChange(i))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card-inner", [`card-${i}`]])
                      }, [
                        _createVNode(_component_SvgIcon, {
                          class: "card-icon",
                          "icon-name": "icon-card-sm"
                        }),
                        _createElementVNode("div", {
                          class: "card-vic-text",
                          textContent: _toDisplayString($setup.getVICPrefix(i) + 'VIC')
                        }, null, 8, _hoisted_11)
                      ], 2)
                    ], 10, _hoisted_10))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_SvgIcon, {
              class: "svg-token",
              "icon-name": "token"
            }),
            _createElementVNode("h5", _hoisted_14, _toDisplayString($setup.getVICPrefix($setup.type)) + "VIC " + _toDisplayString(_ctx.$t('points')) + " : " + _toDisplayString($setup.selectedMemberData?.ProfileDetails?.PointBalance?.toLocaleString() ?? '-'), 1)
          ]),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('points-expiry-date')) + ": " + _toDisplayString($setup.selectedMemberData?.PointBuckets?.[0]?.ExpiryDate ?? '-'), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('current-year-spending')) + ": $" + _toDisplayString($setup.selectedMemberData?.ProfileDetails?.SpendingSummary?.CurrentYear?.toLocaleString() ?? 0), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.links, (link, i) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: i,
              to: {
              name: 'List',
              params: {
                category: link.link,
                lang: _ctx.$i18n.locale,
              }
            },
              class: "info-link-action"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SvgIcon, {
                  class: "svg-action",
                  "icon-name": link.icon
                }, null, 8, ["icon-name"]),
                _createElementVNode("h5", {
                  class: "fw6",
                  textContent: _toDisplayString(_ctx.$t(link.text))
                }, null, 8, _hoisted_15)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]),
      _createElementVNode("h6", {
        class: "info-data info-logout",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onLogout && $setup.onLogout(...args))),
        textContent: _toDisplayString(_ctx.$t('logout'))
      }, null, 8, _hoisted_16)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_SvgIcon, {
        class: "bg-card-wrapper",
        "icon-name": "card-bg"
      }),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("img", {
          class: "bg-card-interface",
          src: $setup.cardImage
        }, null, 8, _hoisted_19),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            class: "vic-card-qr-code",
            src: $setup.qrCode
          }, null, 8, _hoisted_21),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "vic-card-name font-d",
              textContent: _toDisplayString($setup.selectedMemberData?.ProfileDetails?.FirstName ?? '')
            }, null, 8, _hoisted_23),
            _createElementVNode("h4", {
              textContent: _toDisplayString($setup.selectedMemberData?.ProfileDetails.MemberNo)
            }, null, 8, _hoisted_24)
          ])
        ])
      ])
    ])
  ]))
}